// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K6YoK","placeholdersHeader":"styles_placeholdersHeader__3QJM-","editorStyle":"styles_editorStyle__igHSa","placeholdersBox":"styles_placeholdersBox__2ziFz"};